import { IProps } from "./url-table-menu-filter-list.types";
import { memo } from "react";
import { updateUrl } from "./url-table-menu-filter-list.utilities";
import { useHistory, useLocation } from "react-router-dom";
import { useQueryParameters } from "@edgetier/client-components";
import TableMenuFilterList from "../table-menu-filter-list";
import "./url-table-menu-filter-list.scss";

/**
 * Display a list of items that when clicked update the URL.
 * @param props.queryParameter       Name of the URL parameter to read/update.
 * @param props.queryParameterPrefix Optional prefix for the query parameter's name.
 * @param props.tableMenuFilterProps Props to be passed to the table menu filter component.
 * @returns                          List of clickable items.
 */
const UrlTableMenuFilterList = <Item extends {}>({
    queryParameter,
    queryParameterPrefix,
    onItemClick,
    ...tableMenuFilterListProps
}: IProps<Item>) => {
    const { search } = useLocation();
    const { push } = useHistory();

    // Get any already selected values from the URL.
    const { [queryParameter]: value } = useQueryParameters(
        { [queryParameter]: (value): any => value },
        { prefix: queryParameterPrefix }
    );

    /**
     * Update the URL when an item is selected.
     * @param value Selected item's value.
     */
    const onClick = (value: any) => {
        push(updateUrl(queryParameter, queryParameterPrefix, search, value));
        if (typeof onItemClick === "function") {
            onItemClick();
        }
    };

    return <TableMenuFilterList onClick={onClick} value={value} {...tableMenuFilterListProps} />;
};

export default memo(UrlTableMenuFilterList) as typeof UrlTableMenuFilterList;
